<template>
  <match-media v-slot="{ mobile }">
    <div class="owner-edit-pending-dialog-content">
      <h2 v-if="!mobile" class="owner-edit-pending-dialog-content__title">{{ title }}</h2>
      <!--      todo: повторяется шаблон в editDialog, придумать как вынести в отдельный компонент-->
      <v-form-row>
        <v-form-field label="ИМЯ СОБСТВЕННИКА" :error-message="disableFields ? '' : backendErrors.name">
          <template #default="{ validationErrors }">
            <v-input
              :value="localOwnerData.name"
              :disabled="disableFields"
              :is-error="!!validationErrors.length"
              type="text"
              @input="updateLocalOwnerData('name', $event)"
            />
          </template>
        </v-form-field>
      </v-form-row>

      <v-form-row>
        <v-form-field label="ТЕЛЕФОН" :error-message="disableFields ? '' : backendErrors.phone">
          <template #default="{ validationErrors }">
            <v-input-phone
              :value="localOwnerData.phone"
              :disabled="disableFields"
              :is-error="!!validationErrors.length"
              @input="updateLocalOwnerData('phone', $event)"
            >
              <template v-if="successAppend" #append>
                <v-success
                  v-if="successAppend === 'success'"
                  class="owner-edit-pending-dialog-content__success-icon"
                ></v-success>
                <v-not-success v-else></v-not-success>
              </template>
            </v-input-phone>
          </template>
          <template v-if="!disableFields" #error="{ errorMessage }">
            <v-form-user-error :error-message="errorMessage" :user="phoneSearchUser" />
          </template>
        </v-form-field>
      </v-form-row>

      <v-form-row>
        <v-form-field label="EMAIL" :error-message="disableFields ? '' : backendErrors.email">
          <template #default="{ validationErrors }">
            <v-input
              :value="localOwnerData.email"
              :disabled="disableFields"
              :is-error="!!validationErrors.length"
              type="email"
              @input="updateLocalOwnerData('email', $event)"
            />
          </template>
        </v-form-field>
      </v-form-row>

      <v-form-row>
        <v-form-field label="СТАТУС" :error-message="disableFields ? '' : backendErrors.status">
          <template #default="{ validationErrors }">
            <v-select
              :value="localOwnerData.status"
              label="name"
              :disabled="disableFields"
              append-to-body
              :is-error="!!validationErrors.length"
              :options="statusOptions"
              @input="updateLocalOwnerData('status', $event)"
            />
          </template>
        </v-form-field>
      </v-form-row>

      <v-form-row v-if="isRoleAdmin">
        <v-form-field label="АГЕНТ" :error-message="disableFields ? '' : backendErrors.agent">
          <template #default="{ validationErrors }">
            <v-select
              :value="localOwnerData.agent"
              label="name"
              :disabled="disableFields"
              append-to-body
              :is-error="!!validationErrors.length"
              :options="agentOptions"
              @input="updateLocalOwnerData('agent', $event)"
            />
          </template>
        </v-form-field>
      </v-form-row>

      <v-form-row>
        <v-form-field label="ИСТОЧНИК ЛИДА" :error-message="disableFields ? '' : backendErrors.callSource">
          <template #default="{ validationErrors }">
            <v-select
              :value="localOwnerData.callSource"
              label="name"
              :disabled="disableFields"
              append-to-body
              :is-error="!!validationErrors.length"
              :options="callSourceOptions"
              @input="updateLocalOwnerData('callSource', $event)"
            />
          </template>
        </v-form-field>
      </v-form-row>

      <v-form-row>
        <v-form-field
          label="ОБЪЕКТЫ НЕДВИЖИМОСТИ"
          separate-label
          hide-errors
          :error-message="disableFields ? '' : backendErrors.adverts"
        >
          <template #default="{ validationErrors }">
            <v-form-dynamic-select
              :value="localOwnerData.adverts"
              label="name"
              append-to-body
              :disabled="disableFields"
              :is-error="!!validationErrors.length"
              :errors="validationErrors"
              :options="advertOptions"
              prevent-duplicates
              :hide-controls="!editMode"
              @input="updateLocalOwnerData('adverts', $event)"
            >
            </v-form-dynamic-select>
          </template>
        </v-form-field>
      </v-form-row>
    </div>
  </match-media>
</template>

<script>
import VFormRow from '@/components/form/VFormRow.vue'
import VFormField from '@/components/form/VFormField.vue'
import VInput from '@/components/common/VInput.vue'
import VInputPhone from '@/components/common/VInputPhone.vue'
import VSelect from '@/components/common/VSelect.vue'
import VFormDynamicSelect from '@/components/form/VFormDynamicSelect.vue'
import { mapGetters } from 'vuex'
import { MODULE_SESSION } from '@/store/modules/session/session.types'
import { MatchMedia } from 'vue-component-media-queries'
import VFormUserError from '@/components/form/VFormUserError.vue'
import { authService } from '@/services/http'
import VSuccess from '@/components/icons/VSuccess.vue'
import VNotSuccess from '@/components/icons/VNotSuccess.vue'

export default {
  name: 'OwnerEditPendingDialogFormContentWrapper',
  components: {
    VNotSuccess,
    VSuccess,
    VFormUserError,
    MatchMedia,
    VFormDynamicSelect,
    VSelect,
    VInputPhone,
    VInput,
    VFormField,
    VFormRow
  },
  props: {
    title: { type: String, default: '' },
    ownerData: { type: Object, default: () => {} },
    disableFields: { type: Boolean, default: false },
    editMode: { type: Boolean, default: false },
    advertOptions: { type: Array, default: () => [] },
    agentOptions: { type: Array, default: () => [] },
    callSourceOptions: { type: Array, default: () => [] },
    statusOptions: { type: Array, default: () => [] },
    backendErrors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => {
    return {
      phoneSearchUser: null
    }
  },
  computed: {
    successAppend() {
      if (this.phoneSearchUser) {
        if (typeof this.phoneSearchUser === 'string') {
          return 'success'
        }
        return 'not success'
      }
      return ''
    },
    ownerPhone() {
      return this.localOwnerData.phone
    },
    ...mapGetters({
      isRoleAdmin: `${MODULE_SESSION}/isRoleAdmin`
    }),
    localOwnerData: {
      get() {
        return this.ownerData
      },
      set(newValue) {
        this.$emit('change', { ...this.localOwnerData, ...newValue })
      }
    }
  },
  watch: {
    ownerPhone: {
      handler(val) {
        if (val.length === 11) {
          authService.select({ phone: val }).then(({ results }) => {
            this.phoneSearchUser = results[0] || 'noMatches'
          })
        } else {
          this.phoneSearchUser = null
        }
      }
    }
  },
  methods: {
    updateLocalOwnerData(key, value) {
      this.localOwnerData = { [key]: value }
    }
  }
}
</script>

<style scoped lang="scss">
.owner-edit-pending-dialog-content {
  &__title {
    margin-bottom: 20px;
  }
  &__success-icon {
    width: 16px;
  }
}
</style>
